<template>
  <div id="ocupation-area">
    <page-title
      icon="fas fa-table"
      main="Relatório"
      sub="Área de Atuação"
      :help="true"
      titleHelp="Ajuda - Área de Atuação"
      content="Responsável por filtrar as consultas relacionadas a Área de Atuação desde sua criação/atualização."
    >
    </page-title>
    <card class="mt-5">
      <div class="row ">
        <div class="col">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h5 class="h3 mb-0">Area de Atuação</h5>
              <h6 class="text-uppercase text-muted ls-1 mb-1">
                Selecione no mapa a região na qual deseja visualizar os dados
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-12 col-sm-6">
          <anosafra-multiselect
            v-model="filter.anos_safra"
            label="Ano Safra"
            @input="handleInputAnosafra"
          />
        </div>
        <div class="col-12 col-sm-6">
          <label class="form-control-label">Gerente Comercial</label>
          <multiselect
            v-model="filter.manager"
            :options="managers"
            :loading="loading.managers"
            placeholder=""
            label="name"
            track-by="id"
            @input="handleInputManager"
            @search-change="getManagers"
          />
        </div>
        <div class="col-12 col-sm-6">
          <label class="form-control-label">Vendedor</label>
          <multiselect
            v-model="filter.salesman"
            :options="filteredSalesmen"
            :loading="loading.salesman"
            placeholder=""
            label="name"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            track-by="id"
            @input="handleInputSalesma"
            @search-change="getSalesmens"
          />
        </div>
        <div class="col-12 col-sm-6">
          <label class="form-control-label">Clientes</label>
          <multiselect
            v-model="filter.clients"
            :options="clients"
            :loading="loading.clients"
            placeholder=""
            label="razao_social"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            track-by="id"
            @search-change="debouncedSetClients"
          />
        </div>

        <div class="col" v-show="screenWidth < 520">
          <label class="form-control-label">Estados</label>
          <multiselect
            v-model="location"
            :options="loadedStates"
            :loading="isLoading"
            placeholder="Selecione o estado"
            label=""
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            track-by=""
            @input="selectStateSel"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-6 col-md-2">
          <base-button  type="secondary" style="width: 100%; margin-bottom: 28px;" @click="clearFilterBtn">Limpar Filtros</base-button>
        </div>
        <div class="col-12 col-sm-6 col-md-2">
          <base-button color="red" type="neutral" @click="downloadPdf()" v-loading="isLoadingPdfDownload" style="width: 100%; margin-bottom: 28px;" class="text-red mb-2">
            Gerar PDF<i class="fa fa-file-pdf"></i>
          </base-button>
        </div>
        <div class="col-12 col-md-2">
          <base-button type="primary" style="width: 100%; margin-bottom: 28px;" @click="paginated_data.current = 1; filterData()">Filtrar</base-button>
        </div>
      </div>
      <div class="row">
        <div class="svg-map-holder col-12 col-sm-12 col-md-6" v-loading="loading.noteAllAmounts">
          <svg-map
            ref="svgMap"
            style="position: relative;"
            v-model="selectlocation"
            :map="Brazil"
            @click="toggleStateSelection"
            @mouseover="pointLocation"
            @mouseout="unpointLocation"
            @mousemove="moveOnLocation"
          />

			    <div id="svg-map-tooltip" :style="tooltipStyle" v-html="pointedLocation">
			    </div>
          <div
            class="svg-map-icon"
            v-for="(place, index) in iconPosition"
            :key="index"
            :style="{ left: `${place.location.x}px`, top: `${place.location.y}px` }"
            @mouseover="pointIconLocation(place)"
            >
            <i
              class="ni ni-pin-3 icon-index"
              :style="{ fontSize: screenWidth < 768 ? '10px' : (place.region === 'Brasília-DF, Planaltina-DF' ? '12px' : '17px')}"
              > </i>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <div class="row flex-column">
            <div class="col">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-6">
                  <div class="card p-3">
                    <div class="card-title d-flex  flex-row justify-content-between">
                      <p class="h4">Total de Notas</p>
                      <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-blue">
                        <i class="ni ni-shop"></i>
                      </div>
                    </div>
                    <div class="card-body p-0" v-loading="isLoading">
                      <p class="h2">{{note_amounts && note_amounts.nota_not ? note_amounts.nota_not.toLocaleString() : '-'}}</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6">
                  <div class="card p-3">
                    <div class="card-title d-flex  flex-row justify-content-between">
                      <p class="h4">Total em Vendas</p>
                      <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-green">
                        <i class="ni ni-money-coins"></i>
                      </div>
                    </div>
                    <div class="card-body p-0" v-loading="isLoading">
                      <p class="h2">{{note_amounts && note_amounts.vicm_not ? Intl.NumberFormat('pt-BR', {style: 'currency', currency:
                        'BRL'}).format(note_amounts.vicm_not): '-'}}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col">
              <el-table v-loading="isLoading" :data="selectlocation" class="table-striped text-center" :header-cell-style="{paddingLeft: '60px'}" height="400"
                header-row-class-name="thead-light" style="width: 100%;">
                <el-table-column label="Num da Nota" prop="nota_not" align="center" min-width="200px" v-slot="{ row }" sortable>
                  {{ row.nota_not }}
                </el-table-column>
                <el-table-column label="Cliente" prop="dtra_not" align="center" min-width="350px" v-slot="{ row }" sortable>
                  {{ row.dtra_not }}
                </el-table-column>
                <el-table-column label="Valor da Nota" prop="vicm_not" align="center" min-width="200px" v-slot="{ row }" sortable>
                  {{ Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'})
                  .format(row.vicm_not) }}
                </el-table-column>
              </el-table>
              <div class="card-footer py-4 d-flex justify-content-end">
                <base-pagination v-on:input="changePage" v-model="paginated_data.current" :total="paginated_data.count"
                  :perPage="paginated_data.per_page">
                </base-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
  import { SvgMap } from "vue-svg-map";
  import PageTitle from "@/layouts/PageTitle";
  import Brazil from "@svg-maps/brazil"
  import Multiselect from "@/components/Multiselect/translated_multiselect.vue";  
  import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue"
  import { mapState } from 'vuex'

  const PLACES = [
    {
      name: "BsbAgro",
      region: "Marabá-PA",
      quantity: 1,
      location: {
        x: 0.58,
        y: 0.28
      },
    },
    {
      name: "BsbAgro",
      region: "Imperatriz-MA",
      quantity: 1,
      location: {
        x: 0.75,
        y: 0.25
      },
    },
    {
      name: "BsbAgro",
      region: "Paraíso-TO",
      quantity: 1,
      location: {
        x: 0.66,
        y: 0.35
      },
    },
    {
      name: "BsbAgro",
      region: "Paraíso-TO",
      quantity: 1,
      location: {
        x: 0.66,
        y: 0.35
      },
    },
    {
      name: "Vegetal Agro",
      region: "Uruaçu-GO",
      quantity: 1,
      location: {
        x: 0.6375,
        y: 0.46
      },
    },
    {
      name: "Vegetal Agro",
      region: "Padre Bernardo-GO",
      quantity: 1,
      location: {
        x: 0.67,
        y: 0.475
      },
    },
    {
      name: "Vegetal Agro",
      region: "Formosa-GO",
      quantity: 1,
      location: {
        x: 0.685,
        y: 0.478
      },
    },
    {
      name: "Vegetal Agro",
      region: "Brasília-DF (2), Planaltina-DF",
      quantity: 1,
      location: {
        x: 0.685,
        y: 0.499
      },
    },
    {
      name: "Vegetal Agro",
      region: "Formosa-GO",
      quantity: 1,
      location: {
        x: 0.655,
        y: 0.49
      },
    },
    {
      name: "Vegetal Agro",
      region: "Luziânia-GO",
      quantity: 1,
      location: {
        x: 0.67,
        y: 0.525
      },
    },
    {
      name: "Vegetal Agro",
      region: "Cristalina-GO",
      quantity: 1,
      location: {
        x: 0.685,
        y: 0.525
      },
    },
    {
      name: "Vegetal Agro",
      region: "Goiânia-GO",
      quantity: 1,
      location: {
        x: 0.62,
        y: 0.525
      },
    },
    {
      name: "BsbAgro",
      region: "Buritis-MG",
      quantity: 1,
      location: {
        x: 0.72,
        y: 0.50
      },
    }
  ]

  import {
    Table,
    TableColumn
  } from "element-ui";
  export default {
    components: {
      SvgMap,
      PageTitle,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Multiselect,
      AnosafraMultiselect,
    },
    data() {
      return {
        Brazil,
        selectlocation: null,
        isLoading: null,
        loading: {
          anos_safra: false,
          managers: false,
          salesman: false,
          clients: false,
          estates: false,
          noteAllAmounts: false,
        },
        places: PLACES,
        iconPosition: [],
        location: null,
          pointedLocation: null,
          tooltipStyle: null,
          paginated_data: {
            current: 1,
            pages: 0,
          count: 0,
          per_page: 5,
        },
        client_pagination: {
          current: 1,
          pages: 0,
          count: 0,
          per_page: 5,
        },
        clickedState: [],
        filterStates: [],
        filteredSalesmen: [],
        note_amounts: {},
        note_all_amounts: [],
        client_uf_count: {},
        anos_safra: [],
        clients: [],
        managers: [],
        salesmans: [],
        filter: {
          anos_safra: {},
          clients: {},
          manager: {},
          salesman: {}
        },
        isLoadingPdfDownload: false,
        clientsLastSearch: "",
        debounceTimer: null,
        screenWidth: null,
        loadedStates: [],
        data: [],
        amountStaticdata: {},
        stateMapping: {
          'Amazonas': 'AM',
          'Amapá': 'AP',
          'Alagoas': 'AL',
          'Bahia': 'BA',
          'Ceará': 'CE',
          'Espírito Santo': 'ES',
          'Goiás': 'GO',
          'Maranhão': 'MA',
          'Mato Grosso': 'MT',
          'Mato Grosso do Sul': 'MS',
          'Minas Gerais': 'MG',
          'Pará': 'PA',
          'Paraíba': 'PB',
          'Paraná': 'PR',
          'Pernambuco': 'PE',
          'Piauí': 'PI',
          'Rio Grande do Norte': 'RN',
          'Rio Grande do Sul': 'RS',
          'Rio de Janeiro': 'RJ',
          'Rondônia': 'RO',
          'Roraima': 'RR',
          'Santa Catarina': 'SC',
          'São Paulo': 'SP',
          'Sergipe': 'SE',
          'Tocantins': 'TO',
          'Distrito Federal': 'DF',
        },
      }
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.updateIconPosition);
        this.updateIconPosition();
      });
    },
    methods: {
      pointLocation(event) {
        this.updateTooltipValue();
      },
      unpointLocation(event) {
        this.pointedLocation = null
        this.tooltipStyle = { display: 'none' }
      },
      moveOnLocation(event) {
        this.tooltipStyle = {
          position: 'fixed',
          display: 'block',
          top: `${event.clientY - 150}px`,
          left: `${event.clientX - 130}px`,
        }
      },
      pointIconLocation(place) {
        this.pointedLocation = `${place.name} - ${place.region}`;
        this.tooltipStyle = {
          position: 'fixed',
          display: 'block',
          top: `${event.clientY - 150}px`,
          left: `${event.clientX - 130}px`,
        };
      },
      async getData(location = "", current = 1) {
        this.isLoading = true
        try {
          const response = await this.$http.secured.get(`/api/v1/get_amount_notes_by_state/${location}`, {
            params: {
              ...this.queryData(),
              page: this.paginated_data.current,
            }
          })
          this.isLoading = false
          if (response.data) {
            return response.data
          }
        } catch (error) {
          console.warn("[OcupationArea][getData] Error: ", error)
        }
      },
      async getEveryAmountByState() {
        this.loading.noteAllAmounts = true
        try {
          const response = await this.$http.secured.get(`/api/v1/get_amount_by_state`);
          this.note_all_amounts = response.data || [];
          this.filterStates = this.note_all_amounts.map(item => item.uf)

          this.loadStates(this.note_all_amounts)
          this.resetClickedStates()
        } catch (error) {
          console.warn("[OcupationArea][getEveryAmountByState] Error: ", error)
        }
        this.loading.noteAllAmounts = false
      },
      setPagination(current, pages, per_page, count) {
        this.paginated_data = {
          pages: pages,
          current: current,
          per_page: per_page,
          count: count

        }
      },
      async selectState(e) {
        this.resetClickedStates()
        if (e.target) {
          this.clickedStates(e)
          this.location = e.target.id
        }

        this.loadClients()
        this.filter.clients = null

        if (this.filterStates.includes(this.location.toUpperCase())) {
          if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
          }
          this.debunceTimer = setTimeout(async () => {
            this.paginated_data.current = 1
            this.filterData()
          }, 1000)
        }
      },
      selectStateSel(e) {
        const locations = Brazil.__ob__.dep.subs[1].vm.$el

        for (let i = 0; i < locations.children.length; i++) {

          if (this.filterStates.includes(locations.children[i].id.toUpperCase())) {
            locations.children[i].style.fill = "#00f880"

          }
          if (locations.children[i].id == e) {
            locations.children[i].style.fill = "#08d011"
          }
        }
        this.selectState(e)

      },
      async changePage() {
        this.filterData()
      },
      loadStates(data) {
        this.loadedStates = data.map(item => item.uf.toLocaleLowerCase()) || []
        const locations = Brazil.__ob__.dep.subs[1].vm.$el
        this.fillMap(this.loadedStates, locations)
      },
      clickedStates(e) {
        this.clickedState.push(e)
        this.clickedState.forEach(item => {
          if (this.filterStates.includes(e.target.id.toUpperCase())) {
            e.target.style.fill = "#08d011"
          }
        })
      },
      fillMap(selectedEstates, locations) {
        for (let i = 0; i < 27; i++) {
          locations.children[i].style.fill = "#E1E1E1"
          locations.children[i].style.cursor = 'not-allowed'
          if (selectedEstates.includes(locations.children[i].id)) {
            locations.children[i].style.fill = "#00f880"
            locations.children[i].style.cursor = 'pointer'
          }
        }
      },
      resetClickedStates() {
        this.clickedState.forEach(item => {
          if (this.filterStates.includes(item.target.id.toUpperCase())) {
            item.target.style.fill = "#00f880"
          } else {
            item.target.style.fill = "#E1E1E1"
          }
        });
      },
      toggleStateSelection(event) {
        const stateId = event.target.id.toLowerCase();
        
        if (this.location === stateId) {
          this.location = null;
          this.resetClickedStates();
          this.note_amounts = {},
          this.note_all_amounts = []
          this.selectlocation = null
          return;
        }
          
        this.location = stateId;
        this.selectState(event); 
      },
      setClientPagination(current, pages, per_page, count) {
        this.client_pagination = {
          current,
          pages,
          per_page,
          count
        }
      },
      loadMoreClients() {
        const { current, per_page, pages } = this.client_pagination
        const totalPages = Math.ceil(pages / per_page)
        if (current < totalPages) {
          this.client_pagination.current++
          this.loadClients()
        }
      },
      async loadClients() {
        this.loading.clients = true
        try {
          const response = await this.$http.secured.get("/api/v1/clients", {
            params: {
              page: this.client_pagination.current,
              uf: this.location
            }
          })
          const { clients, current, pages, per_page, count } = response.data

          this.setClientPagination(current, pages, per_page, count)
          this.clients = (clients || []).map(item => ({
            id: item.id,
            code: item.code,
            name: item.name,
            razao_social: item.razao_social,
            uf: item.uf,
          }))
        } catch (error) {
          console.warn("[OcupationArea][loadClients] Error: ", error)
        }
        this.loading.clients = false
      },
      async getUsersCountByUF() {
        try {
          const response = await this.$http.secured.get(`/api/v1/clients/users_count_by_uf`);
          if (response.data) {
              this.client_uf_count = response.data;
            }

          } catch (error) {
            // this.$toasted.global.defaultError({ msg: 'Ops... tivemos um problema' });
          }
      },
      svgMapWidth() {
        return this.$refs.svgMap ? this.$refs.svgMap.$el.clientWidth : 0
      },
      svgMapHeight() {
        return this.$refs.svgMap ? this.$refs.svgMap.$el.clientHeight : 0
      },
      updateIconPosition() {
        if (!this.$refs.svgMap) return []

        const rect = this.$refs.svgMap.$el.getBoundingClientRect();

        this.iconPosition = this.places.map(place => ({
          ...place,
          location: {
            x:  rect.width  * place.location.x,
            y:  rect.height * place.location.y,
          },
        }));
      },
      fillData(note_amount, notes) {
        this.note_amounts = note_amount
        this.selectlocation = notes
        this.isLoading = false
      },
      updateTooltipValue() {
        const uf = this.stateMapping[event.target.ariaLabel];
        const totalSales   = this.amountByUF[uf] ? Intl.NumberFormat('pt-BR', {style: 'currency', currency:'BRL'}).format(this.amountByUF[uf] && this.amountByUF[uf].vicm_not || 0) : '-';
        const totalClients = this.clientByUF[uf] ? (this.clientByUF[uf] || 0).toLocaleString() : '-';
        const totalNotes   = this.amountByUF[uf] ? (this.amountByUF[uf].nota_not || 0).toLocaleString() : '-';

        this.pointedLocation = `
          ${event.target.ariaLabel}<br>
          Total em Vendas:   ${totalSales}<br>
          Total de Clientes: ${totalClients}<br>
          Total de Notas:    ${totalNotes}<br>
        `;

      },
      queryData() {
        const queryData = {}

        if (this.location)          queryData.location    = this.location
        if (this.filter.clients)    queryData.client      = this.filter.clients.code
        if (this.filter.anos_safra) queryData.anosafra_id = this.filter.anos_safra.id
        if (this.filter.manager)    queryData.manager_id  = this.filter.manager.id
        if (this.filter.salesman)   queryData.salesman_id = this.filter.salesman.id

        return queryData
      },
      async filterData() {
        this.isLoading = true

        const stateQueryData = this.queryData()
        const noteQueryData = { page: this.paginated_data.current, ...this.queryData() }

        try {
          const [notes, amount] = await Promise.all([
            this.$http.secured.get(`/api/v1/get_amount_notes_by_state/${this.location}`, { params: noteQueryData }),
            this.$http.secured.get(`/api/v1/get_amount_by_state`, { params: stateQueryData })
          ])

          this.setPagination(notes.data.current, notes.data.pages, notes.data.per_page, notes.data.count)

          if (!notes.data.note.length && !amount.data.length) {
            this.fillData([], [])
          } else if (!this.location) {
            const sum = {
              uf: null,
              nota_not: amount.data.reduce((acc, item) => acc + parseFloat(item.nota_not || 0), 0),
              vicm_not: amount.data.reduce((acc, item) => acc + parseFloat(item.vicm_not || 0), 0),
            }
            this.fillData(sum, [])
          } else {
            this.fillData(amount.data[0], notes.data.note)
            this.errors = []
          }
        } catch(error) {
          console.warn("[OcupationArea][filterData] Error: ", error)
        }
      },
      cleanFilters() {
        this.filter = {
          clients: '',
          anos_safra: '',
          manager: '',
          salesman: '',
        }
        this.getSalesmens()
      },
      clearFilterBtn() {
        this.cleanFilters()
        this.paginated_data.current = 1
        this.filterData()
      },
      debouncedSetClients(query) {
        this.loading.clients = true;
        // if (!query) return;
        if (this.clientsTimeout) clearTimeout(this.clientsTimeout);

        this.clientsTimeout = setTimeout(() => this.setClients(query), 500)
      },
      async setClients(query) {
        this.loading.clients = true;
        const currentTimestamp = new Date().getTime();
        this.clientsLastSearch = currentTimestamp;

        var data = {
          q: {},
          per_page: 5,
        };

        if (this.filter.salesman && this.filter.salesman.id) data.q.salesman_id = this.filter.salesman.id;
        if (query) data.q.fulltext = query

        try {
          const response = await this.$http.secured.get("/api/v1/clients", { params: data })

          if (this.clientsLastSearch != currentTimestamp) return;

          this.clients = response.data["clients"] || [];
        } catch (error) {
          console.warn("[OcupationArea][setClients] Error: ", error)
        }
        this.loading.clients = false;
      },
      handleInputManager(manager) {
        if (!manager) return this.filteredSalesmen = this.salesmans || [];

        this.filterSalesmen(manager)
      },
      handleInputSalesma() {
        this.debouncedSetClients('')
        this.filter.clients = null
      },
      handleInputAnosafra() {
        this.getManagers()
        this.getSalesmens()
      },
      async getManagers(query) {
        this.loading.managers = true;
        try {
          const response = await this.$http.secured.get("/api/v1/users", {
            params: {
              q: { name: query, is_manager: true, anosafra_id: this.filter.anos_safra ? this.filter.anos_safra.id : null, status: this.active },
            },
          })
          this.managers = response.data.users || [];
        } catch (error) {
          console.warn("[OcupationArea][getManagers] Error: ", error)
        }
        this.loading.managers = false;
      },

      async getSalesmens(query) {
        this.loading.salesman = true;
        var data = {
          per_page: 10,
          q: { name: query, is_salesman: true, status: this.active },
        };

        if (this.filter.manager && this.filter.manager.id)
          data.q["manager_id"] = this.filter.manager.id;
        if (this.filter.anos_safra && this.filter.anos_safra.id)
          data.q["anosafra_id"] = this.filter.anos_safra.id;

        try {
          const response = await this.$http.secured.get("/api/v1/users", { params: data })

          this.salesmans = response.data.users || [];
          this.filteredSalesmen = this.salesmans || [];
        } catch (error) {
          console.warn("[OcupationArea][getSalesmens] Error: ", error)
        }
        this.loading.salesman = false;
      },

      filterSalesmen(manager) {
        this.filteredSalesmen = manager.salesmans || [];
      },

      async downloadPdf() {
        this.isLoadingPdfDownload = true;

        try {
          const response = await this.$http.secured.get(`/api/v1/get_amount_by_state.pdf`, {
            responseType: 'arraybuffer',
            params: {
              // ...this.queryData(),
              unpaged: true,
            },
          });

          // Starting file donwload
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.target = "_blank";
          link.setAttribute(
            "download",
            `Area de atuação.pdf`
          );
          document.body.appendChild(link);
          link.click();
        } catch (error) {
          console.error(error);
        }
        this.isLoadingPdfDownload = false;
      },

      async init() {
        this.getEveryAmountByState()
        this.filterData()
        this.getUsersCountByUF()
        this.getManagers()
        this.getSalesmens()
      },
    },
    computed: {
      ...mapState({
        sidebarMinimized: state => state.sidebarMinimized,
      }),
      amountByUF() {
        if (!this.note_all_amounts.length) return {}

        const response = {}

        this.note_all_amounts.forEach(item => {
          response[item.uf] = item
        })

        return response
      },
      clientByUF() {
        return this.client_uf_count
      },

    },
    watch: {
      sidebarMinimized() {
        setTimeout(() => {
          this.updateIconPosition();
        }, 250);
      },
    },
    async beforeMount() {
      this.init()
      this.screenWidth = window.innerWidth
    },
  }
</script>

<style src="vue-svg-map/dist/index.css"></style>

<style lang="scss">
#svg-map-tooltip {
  background-color: rgba(255, 255, 255, 0.87);
  backdrop-filter: blur(10px);
  padding: 5px 10px;
  border-radius: 5px;
  -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  z-index: 999
}
#svg-map-tooltip::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 0 10px;
  border-color: rgba(255, 255, 255, 0.87) transparent transparent transparent;
  backdrop-filter: blur(10px);
  bottom: -10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.svg-map-icon {
  position: absolute;
  font-size: 18px;
  left: 50px;
}
.icon-index {
  position: absolute;
}

#ocupation-area .el-table {
  tr, td {
    text-align: center !important;
  }

  th .cell {
    display: inline-block;
    text-align: center;
    padding-top: 8px;
  }
}
</style>
